import { create } from "zustand"

interface GetStartedStore {
  showCompleteAnimation: boolean
  setShowCompleteAnimation: (showCompleteAnimation: boolean) => void
}

export const useGetStartedStore = create<GetStartedStore>((set) => ({
  showCompleteAnimation: false,
  setShowCompleteAnimation: (showCompleteAnimation) =>
    set({ showCompleteAnimation }),
}))
